var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestTube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.104 0V1.33333H7.43733V3.49533C7.43733 4.26733 7.60467 5.02933 7.928 5.73L10.7827 11.914C11.014 12.416 10.7947 13.01 10.2933 13.2407C10.162 13.302 10.0193 13.3333 9.87467 13.3333H1C0.448 13.3333 0 12.8853 0 12.3333C0 12.1887 0.0313333 12.0453 0.092 11.914L2.94667 5.73C3.27 5.03 3.43733 4.26733 3.43733 3.49533V1.33333H2.77067V0H8.104ZM6.104 1.33333H4.77067V4H6.104V1.33333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestTube);
export default __webpack_public_path__ + "static/media/test-tube.40d93e6c26a2b5b2be396e4269c890bf.svg";
export { ForwardRef as ReactComponent };